import * as React from 'react'
import { cn } from '@/lib/utils'

export function AdminTableCard({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-border bg-card shadow-card overflow-hidden',
        className,
      )}
      {...props}
    />
  )
}

export function AdminTable({
  className,
  ...props
}: React.TableHTMLAttributes<HTMLTableElement>) {
  return <table className={cn('w-full font-inter', className)} {...props} />
}

export function AdminTableHead({
  className,
  ...props
}: React.ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={cn(
        'px-6 py-4 text-left text-label font-semibold uppercase text-subtle-foreground',
        className,
      )}
      {...props}
    />
  )
}

export function AdminTableRow({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={cn('border-t border-border-subtle transition-colors hover:bg-muted', className)}
      {...props}
    />
  )
}

export function AdminTableCell({
  className,
  ...props
}: React.TdHTMLAttributes<HTMLTableCellElement>) {
  return <td className={cn('px-6 py-4 text-data text-foreground-secondary tabular-nums', className)} {...props} />
}
